export const recordABI = [
  {
    inputs: [
      { internalType: "string", name: "_name", type: "string" },
      { internalType: "uint8", name: "_age", type: "uint8" },
      { internalType: "string", name: "_gender", type: "string" },
      { internalType: "string", name: "_bloodgroup", type: "string" },
      { internalType: "string", name: "_patientaddress", type: "string" },
      { internalType: "string", name: "_patientillness", type: "string" },
      {
        internalType: "string",
        name: "_patientmedicalrecords",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "getUser",
    outputs: [
      {
        components: [
          { internalType: "string", name: "name", type: "string" },
          { internalType: "uint8", name: "age", type: "uint8" },
          { internalType: "string", name: "gender", type: "string" },
          { internalType: "string", name: "bloodgroup", type: "string" },
          { internalType: "string", name: "patientaddress", type: "string" },
          { internalType: "string", name: "patientillness", type: "string" },
          {
            internalType: "string",
            name: "patientmedicalrecords",
            type: "string",
          },
        ],
        internalType: "struct UserEntity.User",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];
